import { Upload } from 'antd';
import { FunctionComponent } from 'react';

/**
 * FormFileUpload props
 */
interface Props {
  buttonLabel?: string;
}

/**
 * FormFileUpload Component
 */
const FormFileUpload: FunctionComponent<Props> = ({ buttonLabel }) => (
  <Upload>
    <div className="border bg-white p-2 flex flex-row rounded items-center gap-2">
      <div className="bg-gray-200 p-1 px-2 rounded cursor-pointer hover:bg-gray-300">
        <span
          className="text-blue text-xs font-semibold"
          style={{ whiteSpace: 'nowrap' }}>
          {buttonLabel || 'Upload file'}
        </span>
      </div>
      <span className="text-black truncate max-w-[400px]">Select File</span>
    </div>
  </Upload>
);

FormFileUpload.defaultProps = {
  buttonLabel: undefined,
};

export default FormFileUpload;
